// ApprovalPrompt — phone UI shown when the running agent needs approval for a
// mutating action (run_command / write_file). Approve/Reject post the decision
// back to the cloud, which the runner polls to continue or skip.

import TouchButton from '../ui/TouchButton.jsx';

export default function ApprovalPrompt({ request, onDecision }) {
  if (!request) return null;
  return (
    <div
      role="alertdialog"
      aria-label="Aprovação necessária"
      className="flex flex-col gap-3 rounded-lg border border-apolo-accent/40 bg-apolo-surface2 p-4"
    >
      <p className="text-sm font-medium text-apolo-textPrimary">O agente quer executar:</p>
      <pre className="max-h-40 overflow-auto whitespace-pre-wrap break-words rounded-md bg-apolo-bg p-3 text-xs text-apolo-textSecondary">
        {request.desc || '(ação sem descrição)'}
      </pre>
      <div className="flex gap-2">
        <TouchButton variant="danger" onClick={() => onDecision(false)} className="flex-1">
          Rejeitar
        </TouchButton>
        <TouchButton variant="primary" onClick={() => onDecision(true)} className="flex-1">
          Aprovar
        </TouchButton>
      </div>
    </div>
  );
}
